import { stringify as stringifyQs } from "qs";
import urlJoin from "url-join";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  Pagination,
  Sort,
  TabActionDialog
} from "../types";

const mallSectionUrl = "/malls/";

export enum MallShippingLogsSortField {
  created_date = "created_date"
}
export type MallShippingLogsUrlSort = Sort<MallShippingLogsSortField>;

export enum MallListUrlFiltersEnum {
  status = "status",
  query = "query"
}
export type MallListUrlFilters = Filters<MallListUrlFiltersEnum>;
export type MallListUrlDialog =
  | "assign-status"
  | "deactivate"
  | TabActionDialog;

export type MallListUrlQueryParams = ActiveTab &
  BulkAction &
  MallListUrlFilters &
  Dialog<MallListUrlDialog> &
  Pagination;
export type MallUrlQueryParams = Pagination;

export const mallListPath = mallSectionUrl;

export const mallListUrl = (params?: MallListUrlQueryParams) =>
  mallSectionUrl + "?" + stringifyQs(params);

export const mallPath = (id: string) => urlJoin(mallSectionUrl, id);

export const mallUrl = (id: string, params?: MallUrlQueryParams) =>
  mallPath(encodeURIComponent(id)) + "?" + stringifyQs(params);

export const mallAddPath = urlJoin(mallSectionUrl, "add");

export const mallAddUrl = () => mallAddPath;

export enum MallShippingLogsUrlFiltersEnum {
  event = "event"
}

export type MallShippingLogsUrlFilters = Filters<
  MallShippingLogsUrlFiltersEnum
>;
export type MallShippingLogsUrlQueryParams = BulkAction &
  MallShippingLogsUrlFilters &
  MallShippingLogsUrlSort &
  ActiveTab &
  Pagination;

export const mallShippingLogsSortUrl = (
  id: string,
  params?: MallShippingLogsUrlQueryParams
) => mallPath(encodeURIComponent(id)) + "?" + stringifyQs(params);
